import Splide from '@splidejs/splide';

const renderSourceEl = (source) => {
  const sourceEl = document.createElement('span');
  sourceEl.className = 'source-url';
  sourceEl.innerHTML = `
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.8605 1.5L8.154 0.584C8.01322 0.402903 7.83315 0.256208 7.62735 0.155027C7.42149 0.0538457 7.19533 0.000831525 6.96598 0H5.03398C4.80463 0.000831525 4.57847 0.0538457 4.37265 0.155027C4.16682 0.256208 3.98672 0.402903 3.84598 0.584L3.13948 1.5H8.8605Z" fill="white"/>
      <path d="M5.99998 9C7.10456 9 7.99995 8.10458 7.99995 7.00001C7.99995 5.89544 7.10456 5.00002 5.99998 5.00002C4.89541 5.00002 3.99998 5.89544 3.99998 7.00001C3.99998 8.10458 4.89541 9 5.99998 9Z" fill="white"/>
      <path d="M9.50002 2.49998H2.5C1.8372 2.50078 1.20178 2.76443 0.73311 3.23309C0.264441 3.70176 0.000793927 4.33719 0 4.99999V9.49995C0.000793927 10.1628 0.264441 10.7982 0.73311 11.2669C1.20178 11.7355 1.8372 11.9992 2.5 12H9.50002C10.1628 11.9992 10.7982 11.7355 11.2669 11.2669C11.7355 10.7982 11.9992 10.1628 12 9.49995V4.99999C11.9992 4.33719 11.7355 3.70176 11.2669 3.23309C10.7982 2.76443 10.1628 2.50078 9.50002 2.49998ZM6 9.99998C5.40665 9.99998 4.82664 9.82403 4.33329 9.4944C3.83994 9.16477 3.45542 8.69625 3.22836 8.148C3.0013 7.59983 2.94189 6.99666 3.05764 6.41471C3.1734 5.83277 3.45912 5.29822 3.87868 4.87867C4.29823 4.45911 4.83279 4.17338 5.41473 4.05763C5.99667 3.94187 6.59987 4.00128 7.14805 4.22835C7.6962 4.45541 8.1648 4.83993 8.49442 5.33327C8.82405 5.82662 9 6.40664 9 6.99998C8.99918 7.79542 8.6829 8.55802 8.12047 9.12045C7.55797 9.68287 6.7954 9.99922 6 9.99998Z" fill="white"/>
    </svg>${source}`

  return sourceEl;
}

const renderLoupeBtn = () => {
  const loupeBtn = document.createElement('button');
  loupeBtn.className = 'loupe-btn';
  loupeBtn.innerHTML = `
    <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M9.33333 13.3333H13.3333M13.3333 13.3333H17.3333M13.3333 13.3333V9.33333M13.3333 13.3333V17.3333M20 20L28 28M13.3333 22.6667C8.17868 22.6667 4 18.488 4 13.3333C4 8.17868 8.17868 4 13.3333 4C18.488 4 22.6667 8.17868 22.6667 13.3333C22.6667 18.488 18.488 22.6667 13.3333 22.6667Z" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
  `

  return loupeBtn;
}

const initializeSliderInPopup = (images, defaultSlideIdx = 0, defaultContainer) => {
  // Get main and thumbnail sliders
  const mainSliderList = defaultContainer.querySelector('#main-popup-slider .splide__list');
  const thumbnailSliderList = defaultContainer.querySelector('#thumbnail-popup-slider .splide__list');

  // Populate slides dynamically
  images.forEach((img, index) => {
    // Create main slide
    const mainSlide = document.createElement('li');
    const slideWrapper = document.createElement('div');
    slideWrapper.classList.add('main-popup-slider__slide_wrapper');
    mainSlide.append(slideWrapper);
    mainSlide.className = 'splide__slide';
    mainSlide.dataset.close = '1'
    slideWrapper.innerHTML = `
      <img src="${img.src || img.dataset.src}" alt="${img.alt || `Slide ${index + 1}`}">
       <div class="image-slider__counter">
        <span class="image-slider__current">${index + 1}</span>
        <span class="image-slider__divider">/</span>
        <span class="image-slider__total">${images.length}</span>
      </div>
    `;

    const imgSibling = img.parentElement.nextElementSibling;

    if(imgSibling && imgSibling.classList.contains('img_title')) {
      const clone = imgSibling.cloneNode(true);
      slideWrapper.append(clone)
    } else {
      const imageTitleEl = document.createElement('span');
      imageTitleEl.classList.add('img_title');
      let imgTitleText = '';

      if(index === 0 && img.getAttribute('fetchpriority') === 'high' ) {
        const mainImgTextEl =  defaultContainer.querySelector('.content__hint');
        if(mainImgTextEl) {
          imgTitleText = mainImgTextEl.textContent;
        }
      }
    
      if (imgSibling && imgSibling.tagName === 'FIGCAPTION') {
        imgTitleText = imgSibling.textContent;
      }

      if(imgTitleText) {
        imageTitleEl.textContent = imgTitleText
        slideWrapper.appendChild(imageTitleEl);
      }
    }

    mainSliderList.appendChild(mainSlide);

    // Create thumbnail slide
    if (!thumbnailSliderList) return;
    const thumbnailSlide = document.createElement('li');
    thumbnailSlide.className = 'splide__slide';
    thumbnailSlide.innerHTML = `<img src="${img.src || img.dataset.src}" alt="${img.alt || `Thumbnail ${index + 1}`}">`;
    thumbnailSliderList.appendChild(thumbnailSlide);
  });

  // Initialize main slider
  const mainSliderEl = defaultContainer.querySelector('#main-popup-slider');
  const mainSlider = new Splide(mainSliderEl, {
    type: 'fade',
    pagination: false,
    start: defaultSlideIdx,
    updateOnMove: true,
    rewind: true,
    arrows: true,
    // cover: true,
    breakpoints: {
      768: {
        arrows: false,
        pagination: true,
      },
    },
  }).mount();

  // Initialize thumbnail slider
  const thumbnailSlidere = defaultContainer.querySelector('#thumbnail-popup-slider');
  if (thumbnailSlidere) {
    const thumbnailSlider = new Splide(thumbnailSlidere, {
      fixedWidth: 192,
      fixedHeight: 107,
      isNavigation: true,
      gap: 32,
      focus: 'center',
      start: defaultSlideIdx,
      pagination: false,
      updateOnMove: true,
      // cover: true,
      arrows: false,
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    }).mount();
    // Sync thumbnail slider with main slider
    mainSlider.sync(thumbnailSlider);
  }

  function updateDynamicBullets(splide) {
    const maxVisibleDots = 5; // Maximum number of visible bullets
    const paginationContainer = defaultContainer.querySelector('.splide__pagination');
    const totalSlides = splide.length;
    const currentIndex = splide.index;

    // Get all bullets
    const bullets = Array.from(paginationContainer.children);

    // Determine start and end indices for visible bullets
    let start = Math.max(0, currentIndex - Math.floor(maxVisibleDots / 2));
    let end = Math.min(totalSlides - 1, start + maxVisibleDots - 1);

    // Adjust start if near the end
    if (end - start + 1 < maxVisibleDots) {
      start = Math.max(0, end - maxVisibleDots + 1);
    }

    // Update visibility of bullets
    bullets.forEach((bullet, index) => {
      if (index >= start && index <= end) {
        bullet.style.display = 'inline-block';
      } else {
        bullet.style.display = 'none';
      }

      // Add classes for dynamic effect
      bullet.classList.remove('splide__pagination--dynamic');
      if ((index + 2 === currentIndex || index - 2 === currentIndex) && currentIndex > 1 && currentIndex < totalSlides - 2) {
        bullet.classList.add('splide__pagination--dynamic');
      }
    });

    // Center the pagination container
    paginationContainer.style.justifyContent = 'center';
  }

  if (window.innerWidth <= 480) {
    updateDynamicBullets(mainSlider);
    mainSlider.on('move', function () {
      updateDynamicBullets(mainSlider);
    });
  }

  return mainSlider;
}

export const initializeArticlePopup = (defaultContainer = document, defaultContentContainer) => {
  const images = []
  const contentContainer = defaultContentContainer || defaultContainer.querySelector('.content .content__inner');
  images.push(defaultContainer.querySelector('.content__main-image img'));

  const allImagesEl = contentContainer.querySelectorAll('img')
  // omit content-image-slider-thumbnails as it is already in the main slider
  const imagesEl =Array.from(allImagesEl).filter(img => {
  return !img.closest('.content-image-slider-thumbnails, .splide__slide--clone');
}); // Adjust the selector as needed

  imagesEl.forEach((img) => {
    images.push(img);
    const imgWrapper = document.createElement('div');
    imgWrapper.className = 'img-wrapper';
    // Insert the wrapper into the DOM before the img
    img.parentNode.insertBefore(imgWrapper, img);

    // Move the img into the wrapper
    imgWrapper.appendChild(img);
    imgWrapper.appendChild(renderLoupeBtn());
    if (img.hasAttribute('data-source-url')) {
      imgWrapper.appendChild(renderSourceEl(img.getAttribute('data-source-url')));
    }
  })


  const imagesPopup = defaultContainer.querySelector('.images-popup');
  const loupeBtns = defaultContainer.querySelectorAll('.loupe-btn');
  const closeBtn = imagesPopup.querySelector('.images-popup__close');

  imagesPopup.addEventListener('click', (e) => {
    if (e.target.dataset.close === "1") {
      imagesPopup.classList.add('images-popup_hidden');
    }
  });

  closeBtn.addEventListener('click', () => {
    imagesPopup.classList.add('images-popup_hidden');
  })

  let sliderInstanceRef;
  loupeBtns.forEach((btn, index) => {
    btn.addEventListener('click', () => {

      if (imagesPopup.dataset.initialized !== '1') {
        imagesPopup.setAttribute('data-initialized', '1');
        sliderInstanceRef = initializeSliderInPopup(images, index, defaultContainer);
        imagesPopup.classList.remove('images-popup_hidden');
      } else {
        imagesPopup.classList.remove('images-popup_hidden');
        imagesPopup.setAttribute('data-initialized', '1');
        sliderInstanceRef.go(index);
      }

    });
  });
}

export const handleSwipeDownArticlePopup = () => {
  const popupElement = document.querySelector('.images-popup');

  if(popupElement) {
    let startY = 0;
    let currentY = 0;
    let isDragging = false;

    const threshold = 80; 
    const dragLimit = 150; 

    popupElement.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      startY = touch.clientY;
      isDragging = true;
      popupElement.style.transition = 'none';
    });

    popupElement.addEventListener('touchmove', (e) => {
      if (!isDragging) return;

      const touch = e.touches[0];
      currentY = touch.clientY;
      const deltaY = currentY - startY;

      if (deltaY > 0) {
        const dragY = Math.min(deltaY, dragLimit);
      }
    });

    popupElement.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;

      const deltaY = currentY - startY;
      currentY = 0;
      startY = 0;
      if (deltaY > threshold) {
        popupElement.style.transition = 'transform 0.3s ease';
        popupElement.style.transform = `translateY(100%)`;
        setTimeout(() => {
          popupElement.classList.add('images-popup_hidden');
          popupElement.style.transform = `translateY(0)`;
        }, 300);
      } else {
        popupElement.style.transition = 'transform 0.3s ease';
        popupElement.style.transform = 'translateY(0)';
      }
    });
  }
}

window.initializeArticlePopup = initializeArticlePopup;